export * from './survey.component';



// WEBPACK FOOTER //
// ./src/app/layout/survey/index.ts